module.exports = __webpack_public_path__ + "img/vox.7845c7e3.png";